<template>
  <qx-card-form title="成本信息" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <span slot="purchaseDate">
        <qx-tips content="请填写车辆购买的日期，系统将从该日期开始计算车辆的折旧费" />
      </span>
      <div slot="price" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.price" placeholder="请输入购车价格">
          <span slot="suffix" class="inputSlotText">元</span>
        </el-input>
      </div>
      <div slot="residual" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.residual" placeholder="请输入残值">
          <span slot="suffix" class="inputSlotText">元</span>
        </el-input>
      </div>
      <div slot="depreciatedMonth" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.depreciatedMonth" placeholder="请输入折旧月数">
          <span slot="suffix" class="inputSlotText">月</span>
        </el-input>
      </div>
      <span slot="trailerOwnerShip">
        <qx-tips content="顺丰共建车队必须选择一个司机性质" />
      </span>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        // 车辆性质
        trailerOwnerShipOptions: [],
        inline: true,
        form: [
          {
            label: '车辆性质',
            value: 'trailerOwnerShip',
            type: 'select',
            default: '',
          },
          {
            label: '购买时间',
            value: 'purchaseDate',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '购车价格',
            value: 'price',
            type: 'select',
            slot: true,
          },
          {
            label: '折旧月数',
            value: 'depreciatedMonth',
            type: 'input',
            slot: true,
          },
          {
            label: '残值',
            value: 'residual',
            type: 'select',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (trailerOwnerShipOptions) {
      this.baseForm.trailerOwnerShipOptions = trailerOwnerShipOptions;
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (this.showComponent) {
          formData = {
            purchaseDate: this.formatDate(formData.purchaseDate) || '',
            price: formData.price || '',
            residual: formData.residual || '',
            depreciatedMonth: formData.depreciatedMonth || '',
            trailerOwnerShip: formData.trailerOwnerShip || '',
          };
        } else {
          formData = {};
        }
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      console.log('成本提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      this.resetBaseForm(data.vehicleClass);

      if (data.trailerRel) {
        data.purchaseDate = data.trailerRel.purchaseDate || '';
        data.price = data.trailerRel.price || '';
        data.residual = data.trailerRel.residual || '';
        data.depreciatedMonth = data.trailerRel.depreciatedMonth || '';
        data.trailerOwnerShip = data.trailerRel.trailerOwnerShip;
      }
      if (data.trailerOwnerShip !== undefined) {
        data.trailerOwnerShip = String(data.trailerOwnerShip || -1);
      }
      this.$refs.baseForm.setVal(data);
    },
    // 设置所有表单
    resetBaseForm (vehicleClass) {
      if (vehicleClass === '1') {
        this.showComponent = true;
      }
      if (vehicleClass === '2') {
        this.showComponent = false;
      }
    },
    formChange (vehicleClass) {
      this.resetBaseForm(vehicleClass);
    },
    receivedData (vehicleClass) {
      this.formChange(vehicleClass);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
